module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/cx-logo-44b9d50d7ca970306091ef7d69dcf2c4.svg";